import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const translationsKeys: any = {
  'Brak łączności z serwerem': 'events-list.no-connectivity-to-the-server',
  'Holowanie pojazdu': 'events-list.vehicle-towing',
  'Alarm niskiego napięcia akumulatora': 'events-list.low-battery-voltage-alarm',
  'Zanik sygnału GPS podczas jazdy': 'events-list.gps-singal-loss',
  'Praca pojazdu bez zindetyfikowanego pracownika': 'events-list.operation-of-vehicle-without-servant',
  'Uruchomienie pojazdu w niedozwolonym czasie': 'events-list.unauth-starting-vehicle',
  'Alarm przekroczenia dozwolonej prędkości': 'events-list.overspeed',

  '#HDOP': 'vehicle-indicator.hdop',
  'Napięcie zasilania': 'vehicle-indicator.power-voltage',
  'Odległość': 'vehicle-indicator.distance',
  'Poziom sygnału GSM': 'vehicle-indicator.gsm-signal-level',
  'Prędkość': 'vehicle-indicator.speed',
  'Widoczność satelit': 'vehicle-indicator.visibility-satelit',
  'BZ - brak zasilania': 'vehicle-indicator.no-power-supply',
  'ECO - Tryb ECO': 'vehicle-indicator.eco-mode',
  'Zapłon': 'vehicle-indicator.ignition',
  'Prędkość GPS': 'vehicle-indicator.gps-speed',
  'Paliwo': 'vehicle-indicator.fuel',
  'Obroty silnika': 'vehicle-indicator.rpm-engine',
  'Przekroczenie prędkości': 'events-type.speedAlarm',
  'Postój poza obszarem (poprawa bazy obszarów)': 'events-type.outOfAreaStop'
};

@Pipe({
  name: 'translateByText'
})
export class TranslateByTextPipe implements PipeTransform {

  constructor(
    public translate: TranslateService,
  ) {}

  transform(value: string): string {
    if (this.translate.currentLang !== 'pl') {
      return translationsKeys[value] ? this.translate.instant(translationsKeys[value]) : value;
    }
    return value;
  }

}
